import getterTypes from './getter-types'

export default {
  [getterTypes.GET_ORDER]: state => state.order,
}
